import React from "react";
import Header from "../../../layouts/AuthLayout/header/header";
import OrdersSection from "./orders-section";

export default function OrdersPage() {
  return (
    <>
      <Header />
      <OrdersSection />
    </>
  );
}
